import { ComponentConfig } from "@measured/puck";
import { AccordionV2, AccordionV2Props } from "@kunduz/feature-landing-pages";
import {
  cmsIcons,
  defaultComponentSize,
  defaultComponentSizeFields,
} from "../../utils";

export interface AccordionListProps extends AccordionV2Props {}

const AccordionList = (props: AccordionListProps) => {
  return <AccordionV2 {...props} />;
};

export const PuckAccordionList: ComponentConfig<AccordionListProps> = {
  label: "Accordion List",
  fields: {
    accordionItems: {
      type: "array",
      label: "Accordion Items",
      arrayFields: {
        title: { type: "text", label: "Title" },
        icon: { type: "select", label: "Badge Icon", options: cmsIcons },
        content: {
          type: "textarea",
          label: "Content",
        },
      },
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    accordionItems: [
      {
        content:
          "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Neque esse aut possimus ipsum pariatur distinctio, dolores laudantium architecto eius, ratione at velit excepturi consectetur porro doloribus, nesciunt obcaecati voluptatem rerum!",
        title:
          "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Neque esse aut possimus ipsum pariatur distinctio, dolores laudantium architecto eius, ratione at velit excepturi consectetur porro doloribus, nesciunt obcaecati voluptatem rerum!",
        icon: "counseling",
      },
    ],
    options: {
      ...defaultComponentSize,
    },
  },
  render: (props) => <AccordionList {...props} />,
};
